import { connect } from 'react-redux'
import { push } from 'react-router-redux'

import ChangeAliadaConfirm from './ChangeAliadaConfirm'
import { getServices, getAliadas } from '@src/redux/modules/entities'
import {
  fetch as fetchBooking,
  update as updateBooking,
  isFetching as isFetchingBooking,
  isUpdating as isUpdatingBooking
} from '@src/redux/modules/service'
import { fetchAliada } from '@src/redux/modules/aliada'
import * as qs from 'utils/querystring'
import { serviceTypes } from '@src/globals'

const mapStateToProps = (state, ownProps) => {
  const { serviceId: bookingId } = ownProps.params
  const booking = getServices(state)[bookingId]
  const fetchingBooking = isFetchingBooking(state)
  const updatingBooking = isUpdatingBooking(state)

  const replacedAliadaId = parseInt(booking && booking.aliada)
  const replacedAliada = getAliadas(state)[replacedAliadaId]

  const replacementAliadaId = parseInt(qs.parse(ownProps.location.search).replacement_aliada_id)
  const replacementAliada = getAliadas(state)[replacementAliadaId]

  return {
    bookingTypeId: serviceTypes.ONE_TIME.id,
    bookingId,
    booking,
    fetchingBooking,
    updatingBooking,

    replacedAliadaId,
    replacedAliada,

    replacementAliadaId,
    replacementAliada
  }
}

const mapDispatchToProps = {
  fetchBooking,
  updateBooking,
  fetchAliada,
  push
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangeAliadaConfirm)



// WEBPACK FOOTER //
// ./src/screens/App/screens/Services/screens/ChangeAliadaConfirm/ChangeAliadaConfirmContainer.js